import React, { useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'

import File from '../../File'
// import Select from 'components/Select'
import Select from 'react-select'
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
} from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { onSelectDetailCourseThumb } from 'store/Course/actions'
import { onChange } from 'store/Course/actions'
import { createCourse } from 'store/Course/actions'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import CancelModalButton from 'components/Custom/CancelModalButton'

const NewCourse = () => {
  const dispatch = useDispatch()
  const courses = useSelector((state) => state.courses)
  const learningPlanGroups = useSelector(
    (state) => state.groups.learningPlanGroups
  )
  const history = useHistory()
  const location = useLocation()

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  console.log(language)

  const languages = useSelector((state) => state.language.languages)

  useEffect(() => {
    if (location.pathname === '/course/new' && courses.id) {
      history.replace({
        pathname: `/course/${courses.id}/edit`,
      })
    }
  }, [courses, history, location.pathname])

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 35,
      minHeight: 25,
    }),
  }

  return (
    <div className='d-flex justify-content-center mt--6'>
      <Col xl='8' md='10'>
        {/* <Card className='bg-secondary p-2 mb-0 '> */}
        <Card style={{ minHeight: '75vh' }}>
          <CardBody>
            <Row className='justify-content-center'>
              <Form className='col-12'>
                <FormGroup style={{ marginBottom: '2.5rem' }}>
                  <label
                    className='form-control-label font-weight-600 font-weight-600'
                    style={{ fontSize: '16px' }}
                  >
                    {language.learning_plan
                      ? language.learning_plan.name_your_course
                      : 'Name your course'}
                  </label>
                  <Input
                    name='name'
                    autoFocus
                    onChange={(e) => dispatch(onChange(e))}
                    className='form-control-sm '
                    placeholder={
                      language.learning_plan
                        ? language.learning_plan.title_of_the_course
                        : 'Title of the course'
                    }
                    type='text'
                  />
                </FormGroup>
                <FormGroup style={{ marginBottom: '2.5rem' }}>
                  <label
                    className='form-control-label font-weight-600'
                    htmlFor='exampleFormControlTextarea3'
                    style={{ fontSize: '16px' }}
                  >
                    {language.learning_plan
                      ? language.learning_plan.course_description
                      : 'Course Description'}
                  </label>
                  <Input
                    id='exampleFormControlTextarea3'
                    name='description'
                    placeholder={
                      language.learning_plan
                        ? language.learning_plan.course_description
                        : 'Course Description'
                    }
                    onChange={(e) => dispatch(onChange(e))}
                    resize='none'
                    rows='10'
                    type='textarea'
                  />
                </FormGroup>
                <div className='leon gap1'>
                  <FormGroup
                    className='col6 sm-col12'
                    style={{ marginBottom: '2.5rem' }}
                  >
                    <label
                      className='form-control-label font-weight-600'
                      htmlFor='exampleFormControlTextarea3'
                      style={{ fontSize: '16px' }}
                    >
                      {language.courses
                        ? language.courses.select_language
                        : 'Select Language'}
                    </label>
                    <Select
                      maxMenuHeight={200}
                      options={languages.map((item) => {
                        return {
                          value: item.id,
                          label: item.name,
                        }
                      })}
                      onChange={(e) =>
                        dispatch(
                          onChange({
                            target: {
                              name: 'language',
                              value: e.value,
                            },
                          })
                        )
                      }
                      placeholder={
                        language.settings
                          ? language.settings.language
                          : 'Language'
                      }
                      name={'language'}
                      multi={false}
                      valueKey={'id'}
                      clearable={true}
                    />
                  </FormGroup>
                  <FormGroup
                    className='col6 sm-col12'
                    style={{ marginBottom: '2.5rem' }}
                  >
                    <label
                      className='form-control-label font-weight-600'
                      htmlFor='exampleFormControlTextarea3'
                      style={{ fontSize: '16px' }}
                    >
                      Select Course Group
                    </label>
                    <Select
                      maxMenuHeight={200}
                      options={learningPlanGroups.map((item) => {
                        return {
                          value: item.id,
                          label: item.name,
                        }
                      })}
                      onChange={(e) => {
                        dispatch(
                          onChange({
                            target: {
                              name: 'courseGroups',
                              value: e.map((item) => {
                                return {
                                  id: item.value,
                                }
                              }),
                            },
                          })
                        )
                      }}
                      placeholder={'Course Group'}
                      isMulti
                      valueKey={'id'}
                      clearable={true}
                    />
                  </FormGroup>
                </div>

                <div className='leon gap1'>
                  <FormGroup
                    className='col6 sm-col12'
                    style={{ marginBottom: '2.5rem' }}
                  >
                    <label
                      className='form-control-label font-weight-600'
                      style={{ fontSize: '16px' }}
                    >
                      {language.learning_plan
                        ? language.learning_plan.course_thumbnail
                        : 'Course thumbnail'}
                    </label>
                    <File
                      onChange={(e) => dispatch(onSelectDetailCourseThumb(e))}
                      placeholder={
                        language.general ? language.general.choose_file : null
                      }
                    />
                  </FormGroup>

                  <FormGroup
                    className='col6 sm-col12'
                    style={{ marginBottom: '2.5rem' }}
                  >
                    <label
                      className='form-control-label font-weight-600'
                      style={{ fontSize: '16px' }}
                    >
                      {language.courses
                        ? language.courses.reward_points
                        : 'Reward points'}
                    </label>
                    <Input
                      name='rewardPoints'
                      className='form-control-sm'
                      placeholder='eg. 30'
                      type='number'
                      onChange={(e) => dispatch(onChange(e))}
                      value={courses.rewardPoints}
                    />
                  </FormGroup>
                </div>

                <div className='leon gap1'>
                  <FormGroup
                    className='col6 sm-col12 dFlex itemsCenter gap1'
                    style={{ marginBottom: '0' }}
                  >
                    <label
                      className='form-control-label font-weight-600 '
                      htmlFor='promo-course'
                      style={{ fontSize: '16px', margin: '0' }}
                      // style={{ marginRight: '7px', fontSize: '13px' }}
                    >
                      {language.learning_plan
                        ? language.learning_plan.promote_in_dashboard
                        : 'Promote in Dashboard'}
                    </label>
                    <input
                      id='promo-course'
                      type='checkbox'
                      name='promote'
                      chekced={courses.promote}
                      onChange={(e) => dispatch(onChange(e))}
                    />
                  </FormGroup>
                  <FormGroup
                    className='col6 sm-col12 dFlex gap1 justifyEnd'
                    style={{ marginBottom: '0' }}
                  >
                    {/* <Link to={`/user/course/${courses.courses.id}`}> */}

                    {/* </Link> */}
                    <Link to='/learning-plan'>
                      <CancelModalButton
                        text={
                          language.learning_plan ? language.cancel : 'Cancel'
                        }
                      />
                    </Link>

                    <Link>
                      <SubmitModalButton
                        text={
                          language.learning_plan
                            ? language.learning_plan.create_course
                            : 'Create course'
                        }
                        customFn={() => dispatch(createCourse())}
                      />
                    </Link>
                  </FormGroup>
                </div>
              </Form>
            </Row>
          </CardBody>
        </Card>
        {/* </Card> */}
      </Col>
    </div>
  )
}

export default NewCourse
